import type { FC, ReactNode } from 'react';
import { motion } from 'motion/react';
import { Helmet } from 'react-helmet-async';
import { cn } from '@ziggiz/ui';

const APP_NAME = 'Ziggiz';

interface PageProps {
  /** Rendered into `<title>` as `{title} · Ziggiz`. */
  title: string;
  description?: string;
  className?: string;
  children: ReactNode;
}

/**
 * Every routed screen renders exactly one `<Page>`: it owns the document
 * title, the `<main>` landmark, and the shared enter transition.
 */
export const Page: FC<PageProps> = ({ title, description, className, children }) => (
  <>
    <Helmet
      title={`${title} · ${APP_NAME}`}
      meta={description ? [{ name: 'description', content: description }] : []}
    />
    <motion.main
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.24, ease: 'easeOut' }}
      className={cn('mx-auto w-full max-w-5xl flex-1 px-6 py-10', className)}
    >
      {children}
    </motion.main>
  </>
);
